import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import createNetworkingClient from 'utils/networking-client';
import EmbedModal from './EmbedModal';

const EmbedModalWrapper = ({
  embedType: embedTypeProp,
  embedId: embedIdProp
}) => {
  const [embedType, setEmbedType] = useState(embedTypeProp);
  const [embedId, setEmbedId] = useState(embedIdProp);
  const [embedCode, setEmbedCode] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (embedId) {
      createNetworkingClient()
        .get(`/share/dialogs/embed/${embedId}`)
        .then(({ data }) => {
          setEmbedCode(data.embed_code);
        });
    }
  }, [embedId]);

  useEffect(() => {
    function handleOpenDialog(e) {
      if (e.detail.embedId) {
        setEmbedId(e.detail.embedId);
      }
      if (e.detail.embedType) {
        setEmbedType(e.detail.embedType);
      }
      setIsModalOpen(true);
    }

    document.addEventListener('OpenEmbedDialog', handleOpenDialog);

    return () => {
      document.removeEventListener('OpenEmbedDialog', handleOpenDialog);
    };
  }, []);

  function closeModal() {
    setIsModalOpen(false);
  }

  // As embedId is required for EmbedModal do not render it until we have embedId set
  if (!embedId || !embedType) {
    return null;
  }

  return (
    <EmbedModal
      isOpen={isModalOpen}
      onDismiss={closeModal}
      embedType={embedType}
      embedId={embedId}
      embedCode={embedCode}
    />
  );
};

EmbedModalWrapper.propTypes = {
  embedType: PropTypes.string,
  embedId: PropTypes.string
};

EmbedModalWrapper.defaultProps = {
  embedType: null,
  embedId: null
};

export default EmbedModalWrapper;
